module.exports = __webpack_public_path__ + "img/icon_email.c0193f0b.svg";